import { getCurrentInstance } from "vue";
function useSlotValidation(componentName, slots, requiredSlotGroups) {
  const instance = getCurrentInstance();
  requiredSlotGroups.forEach((requiredSlotGroup) => {
    var _a, _b;
    const isGroup = Array.isArray(requiredSlotGroup);
    const hasValidSlot = isGroup ? requiredSlotGroup.some((slot) => slots[slot]) : slots[requiredSlotGroup];
    if (!hasValidSlot) {
      const parentFile = ((_b = (_a = instance == null ? void 0 : instance.parent) == null ? void 0 : _a.type) == null ? void 0 : _b.__file) || "Unknown File";
      const missingSlotsMessage = isGroup ? `One of the following slots is required: [${requiredSlotGroup.join(", ")}]` : `"${requiredSlotGroup}" slot is required`;
      console.warn(
        `[${componentName}]: ${missingSlotsMessage}. Please provide valid slot content.
This issue occurred in "${parentFile}".
`
      );
    }
  });
}
export {
  useSlotValidation
};
//# sourceMappingURL=useSlotValidation.mjs.map
